import React from 'react';
import { NavLink } from 'react-router-dom';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faHome } from '@fortawesome/free-solid-svg-icons';
import PropTypes from 'prop-types';

const Breadcrumb = ({ items }) => {
    return (
        <nav className="flex" aria-label="Breadcrumb">
            <ol className="inline-flex items-center space-x-1 md:space-x-2 rtl:space-x-reverse">
                {items.map((item, index) => (
                    <li key={index} className="inline-flex items-center">
                        {index === 0 ? (
                            <NavLink to={item.link} className="inline-flex items-center text-sm font-medium text-gray-500 dark:text-gray-400 hover:text-[#41A6D7] dark:hover:text-[#41A6D7]">
                                <FontAwesomeIcon icon={faHome} className="mr-2" />
                                {item.label}
                            </NavLink>
                        ) : (
                            <div className="flex items-center">
                                <svg className="rtl:rotate-180 w-3 h-3 text-gray-400 dark:text-gray-600 mx-1" aria-hidden="true" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 6 10">
                                    <path stroke="currentColor" strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="m1 9 4-4-4-4" />
                                </svg>
                                {item.link ? (
                                    <NavLink to={item.link} className="ms-1 text-sm font-medium text-gray-500 dark:text-gray-400 hover:text-[#41A6D7] dark:hover:text-[#41A6D7]">
                                        {item.label}
                                    </NavLink>
                                ) : (
                                    <span className="ms-1 text-sm font-medium text-gray-500 dark:text-gray-400 md:ms-2">{item.label}</span>
                                )}
                            </div>
                        )}
                    </li>
                ))}
            </ol>
        </nav>
    );
};

Breadcrumb.propTypes = {
    items: PropTypes.arrayOf(
        PropTypes.shape({
            label: PropTypes.string.isRequired,
            link: PropTypes.string
        })
    ).isRequired
};

export default Breadcrumb;
